/*
 * Metafield-driven AR / 3D viewer behaviour for product detail pages.
 *
 * Markup is server-rendered by snippets/ar-viewer.liquid in two parts:
 *   - the trigger button, inside the gallery (data-ar-trigger="<section_id>")
 *   - the engine (hidden launcher + modal), at the section root
 *     (data-ar-viewer="<section_id>")
 * They are paired by section_id so the modal can live outside the gallery's
 * transformed stacking context.
 *
 * This script only wires up behaviour:
 *   - on mobile (device can launch native AR): fire Scene Viewer / Quick Look
 *   - on desktop: open an interactive turntable <model-viewer> in the modal
 *
 * Click handling is delegated from the document so it keeps working after the
 * product section is re-rendered (e.g. on variant change), with no re-init.
 */
(function () {
  if (window.__arViewerInit) return;
  window.__arViewerInit = true;

  function getEngine(trigger) {
    var id = trigger.getAttribute('data-ar-trigger');
    return (
      (id && document.querySelector('[data-ar-viewer="' + id + '"]')) ||
      document.querySelector('[data-ar-viewer]')
    );
  }

  function closeModal(modal) {
    var container = modal.querySelector('.ar-viewer__container');
    if (container) container.innerHTML = '';
    modal.classList.remove('active');
    document.body.style.overflow = '';
  }

  function openDesktopViewer(engine, sourceMv) {
    var modal = engine.querySelector('[data-ar-modal]');
    if (!modal) return;
    var container = modal.querySelector('.ar-viewer__container');
    if (!container) return;

    container.innerHTML = '';
    var view = document.createElement('model-viewer');
    view.setAttribute('src', sourceMv.getAttribute('src') || '');
    var iosSrc = sourceMv.getAttribute('ios-src');
    if (iosSrc) view.setAttribute('ios-src', iosSrc);
    view.setAttribute('camera-controls', '');
    view.setAttribute('auto-rotate', '');
    view.setAttribute('environment-image', 'neutral');
    view.setAttribute('shadow-intensity', '1');
    view.setAttribute('exposure', '1');
    view.setAttribute('bounds', 'tight');
    view.setAttribute('camera-orbit', '0deg 75deg auto');
    view.setAttribute('field-of-view', '30deg');
    view.setAttribute('min-camera-orbit', 'auto auto 50%');
    view.setAttribute('max-camera-orbit', 'auto auto 400%');
    view.className = 'ar-viewer__viewer';
    container.appendChild(view);

    modal.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function openAR(trigger) {
    var engine = getEngine(trigger);
    if (!engine) return;
    var mv = engine.querySelector('[data-ar-model]');
    if (!mv) return;

    var fire = function () {
      var nativeBtn = mv.querySelector('[data-ar-native]');
      if (nativeBtn && mv.canActivateAR) {
        nativeBtn.click();
        return;
      }
      openDesktopViewer(engine, mv);
    };

    if (window.customElements && window.customElements.get('model-viewer')) {
      fire();
    } else if (window.customElements && window.customElements.whenDefined) {
      window.customElements.whenDefined('model-viewer').then(fire);
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target;

    var trigger = target.closest('[data-ar-trigger]');
    if (trigger) {
      openAR(trigger);
      return;
    }

    if (target.closest('[data-ar-close]') || target.closest('[data-ar-overlay]')) {
      var modal = target.closest('[data-ar-modal]');
      if (modal) closeModal(modal);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var openModal = document.querySelector('.ar-viewer__modal.active');
    if (openModal) closeModal(openModal);
  });
})();
